var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTokenEthWithBg = function SvgTokenEthWithBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF1F8",
    d: "M14 0c7.733 0 14 6.269 14 14 0 7.733-6.267 14-14 14-7.731 0-14-6.268-14-14C0 6.269 6.269 0 14 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8992B1",
    fillRule: "evenodd",
    d: "M14.113 3.951 7.145 14.207l6.968-2.695z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#656790",
    fillRule: "evenodd",
    d: "m7.145 14.207-.004.006 1.423.682 5.55 2.66v-6.042z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#666690",
    fillRule: "evenodd",
    d: "M14.113 3.951v7.56l.085-.031 6.846 2.672z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#474876",
    fillRule: "evenodd",
    d: "m21.086 14.214-3.119 1.494-3.854 1.847v-6.042l.086-.034 6.845 2.673z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A91B6",
    fillRule: "evenodd",
    d: "M14.113 23.672V18.51l-2.925-1.388-4.387-2.284z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#61688A",
    fillRule: "evenodd",
    d: "m17.038 17.123-2.925 1.386v5.163l7.312-8.833v-.001z",
    clipRule: "evenodd"
  })));
};
export { SvgTokenEthWithBg as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDBDMjEuNzMyNyAwIDI4IDYuMjY4NTYgMjggMTRDMjggMjEuNzMyNyAyMS43MzI3IDI4IDE0IDI4QzYuMjY4NTYgMjggMCAyMS43MzIxIDAgMTRDMCA2LjI2ODU2IDYuMjY4NTYgMCAxNCAwWiIgZmlsbD0iI0VGRjFGOCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjExMzIgMy45NTE0Mkw3LjE0NDUzIDE0LjIwNjZMMTQuMTEzMiAxMS41MTE5VjMuOTUxNDJaIiBmaWxsPSIjODk5MkIxIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy4xNDUxMiAxNC4yMDcxTDcuMTQwNjIgMTQuMjEzNUw4LjU2MzUyIDE0Ljg5NTJMMTQuMTEzOCAxNy41NTUzVjExLjUxMjVMNy4xNDUxMiAxNC4yMDcxWiIgZmlsbD0iIzY1Njc5MCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjExMzMgMy45NTE0MlYxMS41MTE5TDE0LjE5NzkgMTEuNDc5OEwyMS4wNDQyIDE0LjE1MTlMMTQuMTEzMyAzLjk1MTQyWiIgZmlsbD0iIzY2NjY5MCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjA4NTYgMTQuMjEzNUwxNy45NjcxIDE1LjcwNzlMMTQuMTEzMyAxNy41NTUyVjExLjUxMjVMMTQuMTk4OCAxMS40Nzk1TDIxLjA0NDIgMTQuMTUyNEwyMS4wODU2IDE0LjIxMzVaIiBmaWxsPSIjNDc0ODc2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMTEzMyAyMy42NzE4VjE4LjUxTDExLjE4ODMgMTcuMTIyNUw2LjgwMDc4IDE0LjgzNzlMMTQuMTEzMyAyMy42NzE4WiIgZmlsbD0iIzhBOTFCNiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjAzODMgMTcuMTIyNUwxNC4xMTMzIDE4LjUwOTJWMjMuNjcxOEwyMS40MjQ5IDE0LjgzODdWMTQuODM3OUwxNy4wMzgzIDE3LjEyMjVaIiBmaWxsPSIjNjE2ODhBIi8+Cjwvc3ZnPgo=";